import { Form } from 'dash-ui';
import styled from 'styled-components';

export const FormWraper = styled(Form)`
  width: 360px;
  @media ${({ theme }) => theme.devices.mobile} {
    width: 220px;
  }
`;
